import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { IoMdEye } from "react-icons/io";
import { RiPencilFill } from "react-icons/ri";
import PageHeader from '../../../Component/BasicComponents/HeaderBreadCrumbs';
import BasicDataTable from '../../../Component/BasicComponents/BasicDataTable';
import LeadTypeAddAndEditModal from './components/LeadTypeAddAndEditModal';
import { useLeadTypesData } from './hooks/useLead';
import { FaEdit, FaEye } from 'react-icons/fa';


const LeadTypeColumns = (handleEditLeadType: (row: any) => void, handleView: (row: any) => void) => [
    {
        name: "Lead Name",
        selector: (row: { LeadName: string }) => row.LeadName || '-',
        sortable: true,
        width: '25%',
         wrap:true
    },
    {
        name: "Subscriber Types",
        selector: (row: { SubscriberTypes: string|any }) => row.SubscriberTypes?.map((i:any)=>i?.name)?.join(',') || '-',
        sortable: true,
        width: '25%',
         wrap:true
    },
    {
        name: "Outlet Type",
        selector: (row: { OutletTypeName: string|any }) => row.OutletTypeName || '-',
        sortable: true,
        width: '25%',
         wrap:true
    },
    {
        name: "Actions",
        cell: (row: any) => (
            <div className="d-flex align-items-center" style={{}}>
                <div className="d-flex align-items-center">
                    <button
                        onClick={() => handleEditLeadType(row)}
                        className="btn btn-primary"
                        style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
                    >
                        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
                    </button>
                </div>
                <div className="d-flex align-items-center" style={{ marginLeft: 10 }}>
                    <button
                        onClick={() => handleView(row)}
                        className="btn btn-primary"
                        style={{ borderRadius: "20px", padding: "2px", width: "70px", backgroundColor: '#2e8dd3' }}
                    >
                        <FaEye style={{ fill: "#fff" }} />View
                    </button>
                </div>
            </div>
        ),
        width: "25%"
    },
]


const LeadType = () => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>('')
    const [rowData, setRowData] = useState<any>('')

    const [paginationStates, setPaginationStates] = useState<any>({
        limit: 10,
        page: 1,
        search: null,
    });
    const { data } = useLeadTypesData({
        enable: true, params: {
            limit: paginationStates.limit,
            page: paginationStates.page,
            search: paginationStates.search,
        }
    });
   
    console.log('data?.data?.dataaa--->',data?.data?.data)

    const handleEditLeadType = (row:any) => {
        setRowData(row)
        setCheckAddEditStatus('Edit')
        setIsModalOpen(true)
    }
    const handleView = (row:any) => {
        navigate('/leadFields',{state:{leadRowData:row}})
    }
    const toggleModal = () => {
        setCheckAddEditStatus('Add')
        setIsModalOpen(true);
    }
    const handlePagination = (pageNo: number) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
            };
        });
    };
    const handleSearch = (searchValue: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                search: searchValue,
            };
        });
    };

    const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
                limit: limit,
            };
        });
    };


    return (
        <div
            className="p-4"
        >
            <PageHeader
                title="Lead"
                buttons={
                    [
                        {
                            label: "+ Add Lead Type",
                            onClick: toggleModal,
                            color: "#2e8dd3",
                        },
                    ]}
            />
            <BasicDataTable
                paginationTotalRows={data?.recordsTotal || 0}
                onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
                onChangeRowsPerPage={(newPerPage: any, page: any) => {
                    handleonChangeRowsPerPage(newPerPage, page)
                }}
                handleSearch={(val: any) => { handleSearch(val) }}
                Title="Lead Types"
                columns={LeadTypeColumns(handleEditLeadType, handleView)}
                data={data?.data?.data || []}

            />
            <LeadTypeAddAndEditModal rowData={rowData} setCheckAddEditStatus={setCheckAddEditStatus} checkAddEditStatus={checkAddEditStatus} setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} title={checkAddEditStatus == 'Add' ? 'Add Lead Type' : 'Edit Lead Type'} />
        </div>
    )
}

export default LeadType
